export const CADPanelID = 'CADPage-panel';
export const FloatingTabsID = 'CADPage-FloatingTabs';

export const CADPanelType = {
  MeasurementPanel: 'MeasurementPanel',
  AnnotationPanel: 'AnnotationPanel',
};

export const enableFeatureMessage =
  'You are about to enable CAD Diff and Measurement for this customer.';

export const disableFeatureMessage =
  'You are about to disable CAD Diff and Measurement for this customer.';
